import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AuthService } from '@echospaces-web-monorepo/es-auth';
import {
  AccentHexagonComponent,
  IconComponent,
  PageHeaderComponent,
  type EsnIconName,
} from '@echospaces-web-monorepo/es-ui-next';

interface QuickLink {
  readonly id: string;
  readonly icon: EsnIconName;
  readonly title: string;
  readonly text: string;
  readonly route: string;
  readonly superAdminOnly?: boolean;
}

const LINKS: readonly QuickLink[] = [
  { id: 'islands', icon: 'islands', title: 'Islands', text: 'Create, publish and monitor your virtual worlds.', route: '/islands' },
  { id: 'content', icon: 'content', title: 'Content', text: 'Images, videos, audio and 3D models for your spaces.', route: '/content' },
  { id: 'links', icon: 'link', title: 'Link Content', text: 'Place content into the placeholders of each space.', route: '/placeholders-links' },
  { id: 'accounts', icon: 'users', title: 'Client accounts', text: 'Invite people and decide what they may change.', route: '/users', superAdminOnly: true },
];

const SUPER_ADMIN_ROLE = 'super-admin';

/**
 * Portal start page: a short welcome and the way into each work area. Client accounts is
 * offered only to super-admins, matching the sidebar.
 */
@Component({
  selector: 'es-dashboard',
  imports: [AccentHexagonComponent, IconComponent, PageHeaderComponent, RouterLink],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent {
  private readonly auth = inject(AuthService);

  readonly greeting = computed(() => {
    const first = this.auth.user()?.firstName;
    return first ? `Welcome back, ${first}` : 'Welcome back';
  });

  readonly links = computed(() => {
    const superAdmin = this.auth.user()?.roles.includes(SUPER_ADMIN_ROLE) ?? false;
    return LINKS.filter((link) => superAdmin || !link.superAdminOnly);
  });
}
